import { render } from "./CreateCustomer.vue?vue&type=template&id=df0c86e4&scoped=true"
import script from "./CreateCustomer.vue?vue&type=script&lang=js"
export * from "./CreateCustomer.vue?vue&type=script&lang=js"

import "./CreateCustomer.vue?vue&type=style&index=0&id=df0c86e4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df0c86e4"]])

export default __exports__